import { warmupWeekdayCompletionQueryOptions } from '@/src/queries/warmup-queries'
import { getCompletedWeekdaysFromApiCompletion } from '@/src/utils/daily-warmup-completion'
import { getCurrentYearWeek } from '@/src/utils/year-week'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'
import { STATISTICS_CARD_PLACEHOLDER_VALUE } from './statistics-card.constants'

export function WarmupsMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const yearWeek = getCurrentYearWeek()
  const warmupWeekdayCompletionQuery = useSuspenseQuery({
    ...warmupWeekdayCompletionQueryOptions(yearWeek),
    select: (data) => ({
      total: getCompletedWeekdaysFromApiCompletion(data).length,
    }),
  })
  const warmupsThisWeek = warmupWeekdayCompletionQuery.data.total

  return (
    <StatisticsMetricCard
      id="warmups"
      title={t('statistics:metric_warmups_title')}
      value={
        warmupsThisWeek == null
          ? STATISTICS_CARD_PLACEHOLDER_VALUE
          : t('statistics:metric_warmups_value_completed', {
              count: warmupsThisWeek,
            })
      }
      timeframe={t('statistics:timeframe_this_week')}
      iconName="warmups"
    />
  )
}
